import { axiosInstance } from "../utils/ApiClient";

export const goalsService = {
  // Get all goals for the current team
  getGoals: async () => {
    try {
      const response = await axiosInstance.get("/goals/");
      return response.data;
    } catch (error) {
      console.error("Error fetching goals:", error);
      throw error;
    }
  },

  // Create a new goal
  createGoal: async (goalData) => {
    try {
      const response = await axiosInstance.post("/goals/", goalData);
      return response.data;
    } catch (error) {
      console.error("Error creating goal:", error);
      throw error;
    }
  },

  // Update an existing goal
  updateGoal: async (goalId, goalData) => {
    try {
      const response = await axiosInstance.put(`/goals/${goalId}/`, goalData);
      return response.data;
    } catch (error) {
      console.error("Error updating goal:", error);
      throw error;
    }
  },

  // Delete a goal
  deleteGoal: async (goalId) => {
    try {
      await axiosInstance.delete(`/goals/${goalId}/`);
      return true;
    } catch (error) {
      console.error("Error deleting goal:", error);
      throw error;
    }
  },

  // Get a specific goal by ID
  getGoal: async (goalId) => {
    try {
      const response = await axiosInstance.get(`/goals/${goalId}/`);
      return response.data;
    } catch (error) {
      console.error("Error fetching goal:", error);
      throw error;
    }
  },

  // Update goal progress
  updateGoalProgress: async (goalId, progressData) => {
    try {
      const response = await axiosInstance.patch(
        `/goals/${goalId}/`,
        progressData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating goal progress:", error);
      throw error;
    }
  },
};
